<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">{{ title }}</div>
    <!-- 地址列表 -->
    <div class="mainBox">
      <div class="mainBox_list">
        <div class="mainBox_listLeft">
          <div class="circle"></div>
          <div class="mainBox_listTitle">手机绑定</div>
          <div class="mainBox_listText">
            您验证的手机：{{ phone }}若已丢失或停用，请立即更换，避免账号被盗
          </div>
        </div>
        <el-link
          type="primary"
          :underline="false"
          style="
            font-size: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          "
          @click="gotoDetails('/bindPhone')"
          >修改</el-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      phone: this.$cookies.get("userInfo").phone,
    };
  },
  mounted() {
    this.phone = this.phone.substring(0, 3) + "****" + this.phone.substring(7);
  },
  methods: {
    gotoDetails(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/editPhone";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/editPhone.vue